import { useState, useCallback, useEffect } from 'react';
import { applyJoinPhoneCertification, verifyJoinPhoneCertification } from 'app/api';
import dayjs from 'app/libs/dayjs';

function useJoinPhoneCertification() {
	const [phoneCertificationInfo, setPhoneCertificationInfo] = useState(null);
	const [certificationCodeExpireTime, setCertificationCodeExpireTime] = useState(null);
	const [certificationCodeRemainTime, setCertificationCodeRemainTime] = useState(null);
	// 1분에 5번 이상 호출로 블락된 유저 여부
	const [isBlockedUser, setIsBlockedUser] = useState(false);

	useEffect(() => {
		let timer;

		if (certificationCodeExpireTime) {
			timer = setInterval(() => {
				const diff = certificationCodeExpireTime - dayjs();

				if (diff < 1) {
					clearInterval(timer);
				}

				setCertificationCodeRemainTime(dayjs(diff));
			}, 500);
		}

		return () => {
			if (timer) {
				clearInterval(timer);
			}
		};
	}, [certificationCodeExpireTime]);

	const applyPhoneCertification = useCallback(
		async (phoneNumber) => {
			try {
				const { data } = await applyJoinPhoneCertification(phoneNumber);

				if (certificationCodeExpireTime) {
					alert('인증번호가 재발급 되었습니다.');
				} else {
					alert('휴대전화번호로 인증번호가 전송되었습니다.');
				}

				setPhoneCertificationInfo(data);
				setCertificationCodeExpireTime(dayjs().clone().add(3, 'minutes'));

				return data;
			} catch (e) {
				// 10분간 블락된 유저 처리
				if (e.response && e.response?.status === 400 && e.response?.data?.code === '40011') {
					setIsBlockedUser(true);
				}
				// 재발급 실패시 이전 타이머와 UI 초기화
				if (certificationCodeExpireTime) {
					setCertificationCodeExpireTime(null);
					setCertificationCodeRemainTime(null);
				}
				throw e;
			}
		},
		[certificationCodeExpireTime],
	);

	const verifyPhoneCertification = useCallback(
		async (code) => {
			try {
				await verifyJoinPhoneCertification(phoneCertificationInfo.key, code);
				setCertificationCodeExpireTime(null);
				setCertificationCodeRemainTime(null);
				return phoneCertificationInfo;
			} catch (e) {
				throw e;
			}
		},
		[phoneCertificationInfo],
	);

	return {
		isBlockedUser,
		applyPhoneCertification,
		verifyPhoneCertification,
		certificationCodeExpireTime,
		certificationCodeRemainTime,
		isCertificationExpired: certificationCodeRemainTime && parseInt(certificationCodeRemainTime.format('x'), 10) < 1,
	};
}

export default useJoinPhoneCertification;
